<template>
  <div class="mytop" v-cloak>
    <!-- 回答上限ダイアログ -->
    <v-dialog v-model="answerLimitDialog" scrollable max-width="1080">
      <v-card>
        <v-card-title class="headlineBrowseBack headline">
          以下の理由により診断を開始できません。
        </v-card-title>
        <v-card-text
          class="subtitle-1 font-weight-bold"
          v-if="
            this.getLoginUserInfo.max_answer_limit <=
              this.getLoginUserInfo.answer_count
          "
        >
          <br />・回答可能回数が超過しました。追加で受検したい場合は担当営業にご相談ください。
        </v-card-text>
        <v-card-text
          class="subtitle-1 font-weight-bold"
          v-if="!this.getLoginUserInfo.isActive"
        >
          <br />・回答期間が終了しているため、回答できません。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="answerLimitDialog = false"
            >閉じる</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="getLanguage == '日本語'">
      <v-container>
        <v-row
          v-for="n in 1"
          :key="n"
          :class="n === 1 ? 'mb-6' : ''"
          class="mytop_cont"
        >
          <v-col lg="12" md="12" sm="12" cols="12">
            <v-card class="mytop_diagnosis">
              <p
                class="mytop_diagnosisDesc"
                v-if="questionAnswerProgress['created_at'] == null"
              >
                <span class="mytop_descLine">いくつかの質問に答えて、</span>
                <span class="mytop_descLine"
                  >あなたの睡眠偏差値を知りましょう！</span
                >
              </p>
              <p
                class="mytop_diagnosisDesc"
                v-if="questionAnswerProgress['created_at'] != null"
              >
                <span class="mytop_descLine"
                  >前回途中保存された回答があります。</span
                >
                <br />
                <span class="mytop_descLine"
                  >最後まで回答して、あなたの睡眠偏差値を知りましょう！</span
                >
                <v-spacer></v-spacer>
                <span
                  v-if="questionAnswerProgress != false"
                  class="mytop_desc"
                  style="color: black"
                  >途中保存した日付:
                  {{ questionAnswerProgress["created_at"] }}</span
                >
              </p>
              <div>
                <button
                  class="mytop_menuTtl btn_next"
                  v-on:click="toQuestionPath"
                  v-if="
                    questionAnswerProgress['created_at'] == null &&
                      getLoginUserInfo != ''
                  "
                >
                  診断を開始する
                </button>
                <button
                  class="mytop_menuTtl btn_next"
                  v-on:click="toQuestionPath"
                  v-if="questionAnswerProgress['created_at'] != null"
                >
                  続きから再開する
                </button>
              </div>
            </v-card>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-card link class="mytop_card" v-on:click="toAnalyticsPath">
              <p class="mytop_cardTtl">
                <v-icon large color="green darken-2">mdi-trending-up</v-icon
                >分析レポート
              </p>
              <p class="mytop_desc" style="text-align: center">
                過去の診断結果を振り返ります
              </p>
            </v-card>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-card link class="mytop_card" v-on:click="toProfilePath">
              <p class="mytop_cardTtl">
                <v-icon large color="grey darken-2">mdi-account-settings</v-icon
                >プロフィール
              </p>
              <p class="mytop_desc" style="text-align: center">
                プロフィール設定を変更します
              </p>
            </v-card>
          </v-col>
          <v-col lg="12" md="12" sm="12" cols="12">
            <a
              v-if="getLoginUserInfo.report_end_url == '表示する'"
              v-on:click="toSleepTestPath"
            >
              <v-card class="mytop_card">
                <p class="mytop_cardTtl">
                  <v-icon large color="grey darken-2">mdi-sleep</v-icon>
                  睡眠改善コンテンツ
                </p>
                <p class="mytop_desc" style="text-align: center">
                  心身の健康と睡眠をテーマにした改善コンテンツです
                </p>
              </v-card>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- 英語ver -->
    <div v-if="getLanguage == 'English'">
      <v-container>
        <v-row
          v-for="n in 1"
          :key="n"
          :class="n === 1 ? 'mb-6' : ''"
          class="mytop_cont"
        >
          <v-col lg="12" md="12" sm="12" cols="12">
            <v-card class="mytop_diagnosis">
              <p
                class="mytop_diagnosisDesc"
                v-if="questionAnswerProgress['created_at'] == null"
              >
                <span class="mytop_descLine"
                  >Answer a few questions to find out your sleep deviation
                  score!</span
                >
              </p>
              <p
                class="mytop_diagnosisDesc"
                v-if="questionAnswerProgress['created_at'] != null"
              >
                <span class="mytop_descLine"
                  >There is an answer saved in the middle of the last
                  time.</span
                >
                <br />
                <span class="mytop_descLine"
                  >Answer to the end and know your sleep deviation!</span
                >
                <v-spacer></v-spacer>
                <span
                  v-if="questionAnswerProgress != false"
                  class="mytop_desc"
                  style="color: black"
                  >Date saved on the way:
                  {{ questionAnswerProgress["created_at"] }}</span
                >
              </p>
              <div>
                <button
                  class="mytop_menuTtl btn_next"
                  v-on:click="toQuestionPath"
                  v-if="questionAnswerProgress['created_at'] == null"
                >
                  Start diagnostics
                </button>
                <button
                  class="mytop_menuTtl btn_next"
                  v-on:click="toQuestionPath"
                  v-if="questionAnswerProgress['created_at'] != null"
                >
                  Resume from the continuation
                </button>
              </div>
            </v-card>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-card link class="mytop_card" v-on:click="toAnalyticsPath">
              <p class="mytop_cardTtl">
                <v-icon large color="green darken-2">mdi-trending-up</v-icon
                >Analysis report
              </p>
              <p class="mytop_desc" style="text-align: center">
                Looking back on past diagnosis results
              </p>
            </v-card>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-card link class="mytop_card" v-on:click="toProfilePath">
              <p class="mytop_cardTtl">
                <v-icon large color="grey darken-2">mdi-account-settings</v-icon
                >Profile
              </p>
              <p class="mytop_desc" style="text-align: center">
                Change profile settings
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- 英語ver -->
    <div v-if="getLanguage == '中文'">
      <v-container>
        <v-row
          v-for="n in 1"
          :key="n"
          :class="n === 1 ? 'mb-6' : ''"
          class="mytop_cont"
        >
          <v-col lg="12" md="12" sm="12" cols="12">
            <v-card class="mytop_diagnosis">
              <p
                class="mytop_diagnosisDesc"
                v-if="questionAnswerProgress['created_at'] == null"
              >
                <span class="mytop_descLine"
                  >回答几个问题，就能知道自己的睡眠偏差值!</span
                >
              </p>
              <p
                class="mytop_diagnosisDesc"
                v-if="questionAnswerProgress['created_at'] != null"
              >
                <span class="mytop_descLine">上次中途保存了一个答案。</span>
                <br />
                <span class="mytop_descLine"
                  >回答到底，知道您的睡眠偏差値！</span
                >
                <v-spacer></v-spacer>
                <span
                  v-if="questionAnswerProgress != false"
                  class="mytop_desc"
                  style="color: black"
                  >途中保存日期:
                  {{ questionAnswerProgress["created_at"] }}</span
                >
              </p>
              <div>
                <button
                  class="mytop_menuTtl btn_next"
                  v-on:click="toQuestionPath"
                  v-if="questionAnswerProgress['created_at'] == null"
                >
                  开始诊断
                </button>
                <button
                  class="mytop_menuTtl btn_next"
                  v-on:click="toQuestionPath"
                  v-if="questionAnswerProgress['created_at'] != null"
                >
                  从保存处开始作答
                </button>
              </div>
            </v-card>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-card link class="mytop_card" v-on:click="toAnalyticsPath">
              <p class="mytop_cardTtl">
                <v-icon large color="green darken-2">mdi-trending-up</v-icon
                >分析报告
              </p>
              <p class="mytop_desc" style="text-align: center">
                回顾过去的诊断结果
              </p>
            </v-card>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-card link class="mytop_card" v-on:click="toProfilePath">
              <p class="mytop_cardTtl">
                <v-icon large color="grey darken-2">mdi-account-settings</v-icon
                >个人资讯
              </p>
              <p class="mytop_desc" style="text-align: center">
                更改个人资料设置
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- 中文ver -->
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { mapGetters } from "vuex";
import axios from "axios";
import store from "../store";
import { datadogRum } from "@datadog/browser-rum";

export default {
  name: "Profile",
  data() {
    return {
      profileLoadIsFinished: false,
      progressLoadIsFinished: false,
      user: {},
      questionAnswerProgress: { created_at: null },
      loginUserId: "",
      isShowDebugger: 0,
      answerLimitDialog: false,
      outerActiveIntervalDialog: false,
    };
  },
  created() {
    // MyTop遷移時にユーザープロフィールを取得する
    axios
      .get("/users/profile", {
        params: { userName: store.state.loginUserId },
        headers: { Authorization: store.state.accessToken },
      })
      .then((response) => {
        // eslint-disable-next-line
        console.log("get user profile!!!!!", response["data"]);
        // eslint-disable-next-line
        store.commit("setValueToLoginUserInfo", response["data"]);
        this.profileLoadIsFinished = true;
      })
      .catch((err) => {
        (this.errored = true), (this.error = err);
      });
    // MyTop遷移時にアクセストークンを取得する
    Auth.currentSession()
      // eslint-disable-next-line
      .then((data) => {
        // eslint-disable-next-line
        store.commit("setValueToAccessToken", data["accessToken"]["jwtToken"]);
      })
      .catch((error) => {
        error;
      });
    Auth.currentAuthenticatedUser().then((user) => {
      this.user = user;
      // myTopに遷移したタイミングで、途中保存結果有無を取得
      axios
        .get("/questions/progress", {
          params: {
            userName: this.user["username"],
            isComplete: 0,
          },
          headers: { Authorization: this.getAccessToken },
          data: {},
        })
        .then((response) => {
          this.questionAnswerProgress = response.data;
          this.progressLoadIsFinished = true;
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    });

    // DatadogにIDを送信
    datadogRum.init({
      applicationId: "eead9fbb-4600-4f8c-bad8-e63ec5905909",
      clientToken: "pub46f7668ee90b3f345027a094209c168c",
      site: "ap1.datadoghq.com",
      service: "睡眠偏差値",
      env: process.env.NODE_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });

    // 動画計測スタート
    datadogRum.startSessionReplayRecording();

    datadogRum.setUser({
      id: this.getLoginUserId,
      name: this.getLoginUserId,
      email: this.getLoginUserInfo["email"],
      organizationName: this.getLoginUserInfo["company_name"],
    });
  },
  computed: {
    ...mapGetters([
      "getLoginState",
      "getLoginUserId",
      "getAccessToken",
      "getLanguage",
      "getLoginUserInfo",
    ]),
  },
  methods: {
    canAnswer() {
      if (
        this.getLoginUserInfo.max_answer_limit >
          this.getLoginUserInfo.answer_count &&
        this.getLoginUserInfo.isActive
      ) {
        return true;
      } else {
        return false;
      }
    },
    toQuestionPath() {
      if (!this.canAnswer()) {
        this.answerLimitDialog = true;
      } else if (this.questionAnswerProgress == false) {
        this.$router.push({
          name: "question",
          params: { questionAnswerProgress: false },
        });
      } else {
        this.$router.push({
          name: "question",
          params: { questionAnswerProgress: this.questionAnswerProgress },
        });
      }
    },
    toAnalyticsPath() {
      this.$router.push("/analytics");
    },
    toProfilePath() {
      this.$router.push("/profile");
    },
    toSleepTestPath() {
      if (this.getLoginUserInfo.report_end_url == "表示する") {
        this.$router.push("/sleepTestTop");
      } else {
        window.open(this.getLoginUserInfo.report_end_url, "_blank");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
.mytop {
  background: #5592c6;
  min-height: calc(100vh - 96px);
  &_logo {
    width: 160px;
  }
  &_menuTtl {
    padding-left: 50px;
    padding-right: 50px;
  }
  &_diagnosisDesc,
  &_sleepTestDesc {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
    padding-right: 40%;
    margin-left: 16px;
    letter-spacing: 0.04em;
    color: #1d64a1;
    line-height: 1.6;
    @media screen and (max-width: $md) {
      font-size: 14px;
      margin-left: 4px;
    }
  }
  &_descLine {
    display: inline-block;
    @media screen and (max-width: $md) {
      display: inline;
    }
  }
  &_head {
    &-1 {
    }
    &-2 {
      text-align: right;
    }
  }
  &_cont {
    padding: 48px;
    background: rgba(0, 0, 32, 0.2);
    border-radius: 6px;
    max-width: 1280px;
    margin: 0 auto !important;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
  }
  &_diagnosis,
  &_sleepTest {
    background: #fff url(../assets/top_bg.png) center right no-repeat;
    background-size: 40%;
    padding: 48px;
    @media screen and (max-width: $md) {
      padding: 16px;
      background-position: right top;
      .btn_next {
        margin-top: 0;
      }
    }
  }
  &_card {
    padding: 48px;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
    p {
      margin: 0;
    }
  }
  &_card-disabled {
    opacity: 0.7;
  }
  &_cardTtl {
    text-align: center;
    font-size: 24px;
    color: #5592c6;
    font-weight: bold;
    @media screen and (max-width: $md) {
      font-size: 20px;
    }
  }
  &_desc {
    font-size: 15px;
    margin-top: 8px !important;
    @media screen and (max-width: $md) {
      font-size: 13px;
      margin-top: 0 !important;
    }
  }
}
.cards {
  margin-top: 100px;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 48px;
}
.sleepMovie_debugger {
  display: none;
  &.is-show {
    display: block;
  }
}

[v-cloak] {
  display: none;
}
</style>
